export const classes = [
  {
    id:1,
    image:'/images/acrobat1.jpg',
    title:'Beginner Class',
    date:'Mon | 3:15 Pm - 4:00 Pm',
    activity:'Opened',
    day:['S','M','T','W','TH','FR','SaT']
  },
  { 
    id:2,
    image:'/images/acrobat1.jpg',
    title:'Intermediate and Advanced Gymnastics levels',
    date:'Mon | 3:15 Pm - 4:00 Pm',
    activity:'Opened',
    day:['S','M','T','W','TH','FR','SaT']
  },
  { 
    id:3,
    image:'/images/acrobat1.jpg',
    title:'Acrobatics',
    date:'Mon | 3:15 Pm - 4:00 Pm',
    activity:'Opened',
    day:['S','M','T','W','TH','FR','SaT']
  },
  { 
    id:4,
    image:'/images/acrobat1.jpg',
    title:'Tumbling',
    date:'Mon | 3:15 Pm - 4:00 Pm',
    activity:'Opened',
    day:['S','M','T','W','TH','FR','SaT']
  },
  { 
    id:5,
    image:'/images/acrobat1.jpg',
    title:'Rhythmic',
    date:'Mon | 3:15 Pm - 4:00 Pm',
    activity:'Opened',
    day:['S','M','T','W','TH','FR','SaT']
  }
]
export const slotData = [
  {
    id:1,
    time: '2:00 pm - 5:00 pm'
  },
  {
    id:2,
    time:'10:00 am - 3:00 pm'
  }
]

export const GalleryPhoto = [
  {
    image: "/images/Gallery/child1.jpg",
    title: "Young Gymnast in Action",
    category: "Students"
  },
  {
    image: "/images/Gallery/child3.jpg",
    title: "Balance Beam Practice",
    category: "Training"
  },
  {
    image: "/images/Gallery/child4.jpg",
    title: "Group Training Session",
    category: "Group"
  },
  {
    image: "/images/Gallery/child5.jpg",
    title: "Competition Day",
    category: "Events"
  },
  {
    image: "/images/acrobat1.jpg",
    title: "Advanced Acrobatics",
    category: "Training"
  },
  {
    image: "/images/acrobat2.jpg",
    title: "Team Spirit",
    category: "Group"
  },
  {
    image: "/images/acrobat3.jpg",
    title: "Tumbling Excellence",
    category: "Students"
  },
  {
    image: "/images/acrobat4.jpg",
    title: "Beginner's Joy",
    category: "Students"
  }
  // Add more images as needed
];
export const Trainer = [
  {
    name: "Pascal Uwayezu",
    image: "/images/Trainer/pasc.jpg",
    exp: 10,
    desc: "Our founder,Ceo and head coach is a certified gymnastics trainer with over 10 years of experience in coaching and youth development. Holding a recognized international coaching certificate, he established K.I.G.A to inspire and train the next generation of athletes in Rwanda through high-quality, disciplined, and creative gymnastics programs.",
    tel: "078656757",
    social: [
      { name: "instagram", url: "/instagram", icons: "fa-brands fa-instagram" },
      { name: "linkedin", url: "/linkedin", icons: "fa-brands fa-linkedin-in" },
      { name: "whatsapp", url: "/whatsapp", icons: "fa-brands fa-whatsapp" },
    ],
  },
  {
    name: "Habimana Theo",
    image: "/images/Trainer/hab.jpg",
    exp: 4,
    desc: " our coach is a certified gymnastics trainer with over 10 years of experience in coaching and youth development. Holding a recognized international coaching certificate, he established K.I.G.A to inspire and train the next generation of athletes in Rwanda through high-quality, disciplined, and creative gymnastics programs.",
    tel: "078656757",
    social: [
      { name: "instagram", url: "/instagram", icons: "fa-brands fa-instagram" },
      { name: "linkedin", url: "/linkedin", icons: "fa-brands fa-linkedin-in" },
      { name: "whatsapp", url: "/whatsapp", icons: "fa-brands fa-whatsapp" },
    ],
  },
    {
    name: "Francine Fafa",
    image: "/images/Trainer/fafa.jpg",
    exp: 4,
    desc: "Our Secretary of our gymnastics  is a dedicated and highly organized individual who plays a key role in ensuring the smooth operation of all activities. With strong communication and administrative skills, the secretary is responsible for managing records, coordinating meetings, and sharing important information with athletes, coaches, and members.",
    tel: "078656757",
    social: [
      { name: "instagram", url: "/instagram", icons: "fa-brands fa-instagram" },
      { name: "linkedin", url: "/linkedin", icons: "fa-brands fa-linkedin-in" },
      { name: "whatsapp", url: "/whatsapp", icons: "fa-brands fa-whatsapp" },
    ],
  },
];